export const DEFAULT_NUMBER_TEXTBOX_INPUT_TEST_ID = 'numberTextboxInput';
